import React from "react";
import Footeragain from "../../Components/Footeragain";
import Header from "../../Components/Header";
import Social from "../../Components/Social";
import roadback from "../../Assets/img/roadback.webp";
import "../../Assets/css/roadmap.css";

const Roadmap = () => {
  return (
    <>
      <Header />

      {/* Road map inner  */}
      <div className="meet">
        <img className="img-fluid" src={roadback}></img>
      </div>
      <section className="road-map-inner">
        <div className="container">
          <div className="about-head for-road-head">
            <h2>
              ROAD<span>MAP</span>
            </h2>
            {/* <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna <br></br>{" "}
              aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat
            </p> */}
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="all-road-map road-map-1 road-stick">
                <div className="all-roadmap-text  all-road-things">
                  <h5>NFT </h5>
                  <h3>
                    Launching in <span>August 2022 </span>{" "}
                  </h3>
                  <p className="for-road-responsive">
                    About 5,555 NFTs are set to be released in the first batch,
                    divided into 4 tiers:
                    <ul>
                      <li>
                        <b>Special Edition:</b> 5 NFTs
                      </li>
                      <li>
                        <b>God-Tier: </b> Premium and distinct 150 Animated NFTs{" "}
                      </li>
                      <li>
                        <b>Mid-Tier:</b> 1655 animated character NFTs
                      </li>
                      <li>
                        <b>Basic-Tier: </b> 3745 Floating/hovering NFTs
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>

            <div className="col-md-5">
              <div className="all-road-map road-map-2 road-stick">
                <div className="all-roadmap-text all-road-things">
                  <h5>METAVERSE</h5>
                  <h3>
                    Launching in <span>June 2023</span>{" "}
                  </h3>
                  <p className="for-road-responsive">
                    It's a unique kind of digital verse aiming to revolutionize
                    the WEB3 experience. This virtual world is divided into two
                    aspects:
                  </p>
                  <p className="for-road-responsive">
                    <b>Museum Creation:</b> With concepts like a hall of fame
                    and a designated leaderboard, the NFT users will always have
                    something to boast about.
                  </p>
                  <p className="for-road-responsive">
                    <b>Buy & Sell Real Estate:</b> the users can engage in
                    activities like buying and selling land and experience the
                    game through VR, quests, gameplays, and participation.
                    Initially, the VR version will be available to NFT holders,
                    leaderboards, and hall of fame inductees.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-5">
              <div className="all-road-map road-map-3 road-uppder-padding">
                <div className="all-roadmap-text all-road-things">
                  <h5>MIGHTY WINGS GAME </h5>
                  <h3>
                    Release Date <span>August 2023</span>{" "}
                  </h3>
                  <p className="for-road-responsive">
                    Full Game launch of this state-of-the-art multiplayer game,
                    built on the fastest and the best gaming engine in the world
                    –Unreal Engine 5.
                  </p>
                  <p className="for-road-responsive mb-0">
                    The game comes with a detailed campaign mode for each of our
                    characters in an open-world environment where the players
                    will solve different quests.
                  </p>
                  <p className="for-road-responsive">
                    This game would be available on PC, consoles, and
                    <br></br> smartphones.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>

            <div className="col-md-5">
              <div className="all-road-map road-map-4 road-uppder-padding">
                <div className="all-roadmap-text all-road-things">
                  <h5>CRYPTOCURRENCY </h5>
                  <h3>
                    Release Date <span>August 2023 </span>{" "}
                  </h3>
                  <p className="for-road-responsive">
                    Introducing the very first Governance token that allows
                    holders to participate in governanceand make important
                    decisions of the platform using DAO structure. Using this
                    token, the players can buy equipment and customize their
                    Avatar characters in Game and Metaverse.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of Road map inner  */}
      <Social />

      <Footeragain />
    </>
  );
};

export default Roadmap;
